import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { MatSelect } from '@angular/material/select';
import { DataSourceGrid } from '../utils/data-source-grid.component';
import { generalService } from '../services/general.service';
import { DataService } from '../utils/data.service';
import { DatosGeneralesSAE } from '../datos-generales-SAE';
import { Cliente } from '../models/cliente';
import { modalFechaPagoFactura } from '../factura/consultar-eliminar/fechaPago/fecha-pago.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import * as $ from 'jquery';

/**
 * Reporte de Cuentas por Cobrar basado en FACTURA (no en venta).
 * Muestra las facturas TIMBRADAS no pagadas con su saldo pendiente y permite
 * descargar el PDF de "Antigüedad de saldos". Para facturas PUE permite capturar
 * la fecha de pago (mismo modal que la pantalla de factura).
 */
@Component({
  selector: 'cuentasCobrarFactura',
  templateUrl: 'cuentasCobrarFactura.component.html',
  providers: [generalService]
})
export class cuentasCobrarFacturaComponent implements OnInit, AfterViewInit {

  public datosGeneralesSAE: any;

  // Selector de cliente con scroll infinito en memoria (patrón factura)
  public listaCliente: Cliente[] = [];
  public viewDataCliente: any[] = [];
  private arrayFilteredCliente = undefined;
  private filteredItemsShowCliente = 10;
  private isFilteredCliente = false;
  private itemsShow = 10;
  @ViewChild('infiniteSelect') selectElem: MatSelect;

  public clienteForm = new FormControl(null);
  public folio: string = '';

  public listaCuentas: Array<any> = [];
  public dataSource: DataSourceGrid | null;
  public mostrar: boolean = false;

  public displayedColumns = [
    'acciones', 'cliente', 'folio', 'monto', 'metodoPago',
    'fechaFactura', 'fechaVencimiento', 'diasVencimiento'
  ];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialog: MatDialog,
              public dataService: DataService,
              private _generalService: generalService) {
    this.datosGeneralesSAE = DatosGeneralesSAE;
  }

  ngOnInit() {
    this.consultarClientes();
    this.consultar();
  }

  ngAfterViewInit() {
    if (this.selectElem) {
      this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent());
    }
  }

  consultarClientes() {
    const params: any = {};
    params.loacs = sessionStorage.getItem('acslo');
    this._generalService.metodoCallParams(params, 'cliente/consultarClientes').subscribe(
      (result) => {
        const res = JSON.parse(result);
        if (res !== null && res !== undefined) {
          this.listaCliente = res;
          this.viewDataCliente = this.listaCliente.slice(0, 10);
        } else {
          this.listaCliente = [];
          this.viewDataCliente = [];
        }
      },
      (error) => { console.log(<any>error); }
    );
  }

  // Consulta del grid: facturas timbradas no pagadas
  consultar() {
    this.datosGeneralesSAE.showSpinnerLoading = true;
    const params = {
      loacs: sessionStorage.getItem('acslo'),
      idCliente: this.clienteForm.value ? this.clienteForm.value : 0,
      folio: this.folio ? this.folio : ''
    };
    this._generalService.metodoCallParams(params, 'factura/consultarCuentasPorCobrar').subscribe(
      (result) => {
        const res = JSON.parse(result);
        this.listaCuentas = (res !== null && res !== undefined) ? res : [];
        // Cada búsqueda vuelve a la primera página; DataSourceGrid.connect() corta
        // desde pageIndex*pageSize, así que sin esto queda en la página anterior
        // (pie "201 - 210 of 1" y tabla vacía).
        if (this.paginator) { this.paginator.pageIndex = 0; }
        this.dataSource = new DataSourceGrid(this.listaCuentas, this.paginator, this.sort);
        this.mostrar = this.listaCuentas.length > 0;
        // DataSourceGrid no re-emite con arreglo vacío (merge sobre [] no emite),
        // así que las filas previas quedan pintadas. Se limpian a mano, igual que
        // factura-consultar.component.ts (consultarFacturas).
        if (this.listaCuentas.length <= 0) {
          $('.mat-row').remove('.mat-row');
        }
        this.datosGeneralesSAE.showSpinnerLoading = false;
      },
      (error) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
      }
    );
  }

  // Descarga del PDF "Antigüedad de saldos"
  descargar() {
    this.datosGeneralesSAE.showSpinnerLoading = true;
    const params = {
      loacs: sessionStorage.getItem('acslo'),
      idCliente: this.clienteForm.value ? this.clienteForm.value : 0,
      folio: this.folio ? this.folio : ''
    };
    this._generalService.metodoCallParams(params, 'factura/descargarReporteCuentasPorCobrar').subscribe(
      (result) => {
        const archivo = JSON.parse(result);
        const blob = this.base64PDFToBlob(archivo.PDF);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = (archivo.FILENAME_PDF || 'AntiguedadSaldos') + '.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.datosGeneralesSAE.showSpinnerLoading = false;
      },
      (error) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
      }
    );
  }

  // Captura de fecha de pago (solo PUE). Reutiliza el modal de la pantalla de factura.
  fechaPagoFactura(row: any) {
    const dialogRef = this.dialog.open(modalFechaPagoFactura, {
      disableClose: true,
      width: '30%',
      maxWidth: '70%',
      panelClass: 'full-width-dialog',
      data: {
        id: row.CUSTOMER_ID,
        BILL_ID: row.BILL_ID
      }
    });
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe(() => {
      this.consultar();
    });
  }

  base64PDFToBlob(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: 'application/pdf' });
  }

  /***************************INFINITE SELECT**********************************/
  onKeyUpCliente(val: any) {
    let arr: any[];
    if (val.currentTarget.value != '') {
      this.arrayFilteredCliente = this.listaCliente.filter((obj: any) => {
        return obj.razonSocial.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      });
      arr = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
      this.isFilteredCliente = true;
    } else {
      this.isFilteredCliente = false;
      this.filteredItemsShowCliente = 10;
      this.arrayFilteredCliente = undefined;
      arr = this.listaCliente.slice(0, this.itemsShow);
    }
    this.viewDataCliente = arr;
  }

  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if (this.isFilteredCliente) {
        if (this.filteredItemsShowCliente < this.arrayFilteredCliente.length) {
          this.filteredItemsShowCliente += 10;
          this.viewDataCliente = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
        }
      } else {
        if (this.itemsShow < this.listaCliente.length) {
          this.itemsShow += 10;
          this.viewDataCliente = this.listaCliente.slice(0, this.itemsShow);
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/
}




// WEBPACK FOOTER //
// ./src/app/cuentasCobrarFactura/cuentasCobrarFactura.component.ts